import React,{useState} from 'react';
import { ModalContainer,IconContainer,UIcon } from './CreateAdminUser'; 
import {BsThreeDotsVertical as MoreDots} from 'react-icons/bs';
import styled from '@emotion/styled';
import { useSettingModal } from '../../../../hooks/Context';
import {DisableZones} from '.';

const MoreContainer = styled.div`
    position: relative;
    
    & > span{
        cursor: pointer;
    }
    & > div{
        display:none;
        flex-direction: column;
        min-width: 120px;
        padding: 10px 0;
        background-color: #f9f9f9;
        position: absolute;
        right:0;
        top:35px;
        border:1px solid #eee;
    }
    & > div.show{
        display: flex !important;
    }
    
    & > div > span{
        padding:10px;
        background-color: transparent;
        display:inline-block;
        width:100%;
        color:#222;
        cursor: pointer;
        font-size:12px;
    }
    & > div > span:hover{
        background-color:#eee
    }

`

const ViewZones = (props:any) => {
    const [showDisable,setShowDisable] = useState<boolean>(false);
    const {setShowCancel,setShowModal,setModalContent} = useSettingModal();
    const data = props.data;
    const handleDisableZones = () =>{
        setModalContent(<DisableZones data={data} />);
        setShowCancel(true);
        setShowModal(true);
    }
  return (
    <ModalContainer>
         <div>
            <div>
                <div>
                    <IconContainer><UIcon /></IconContainer>
                    <span>Zones</span>
                </div>
                <MoreContainer>
                    <span onClick={()=>setShowDisable(!showDisable)}><MoreDots/></span>
                    <div className={showDisable?'show':''}>
                        <span onClick={handleDisableZones}>Disable Zones</span>
                    </div>
                </MoreContainer>
            </div>
            <ViewContainer>
                <div>Details</div>
                <div>
                    <span>Status</span>
                    <span className={data.status}>{data.status}</span>
                </div>
                <div>
                    <span>Created</span>
                    <span>{data.date}</span>
                </div>
            </ViewContainer>
        </div>
    </ModalContainer>
  )
}

export const ViewContainer = styled.div`
    width:100%;
    display: flex;
    flex-direction: column;
    gap:20px;
    padding:30px;

    & > div:first-of-type{
        font-weight:500;
    }
    & > div:not(:first-of-type){
        display: flex;
        flex:1;
        justify-content:space-between;
    }
    & .Active{
    background-color:#E0FAEE ;
    color:#11643C;
    padding:3px;
    border-radius: 4px;
    font-size:13px
   }
   & .Disabled{
    background-color:#FAE0E0 ;
    color:#DD5151;
    padding:3px;
    border-radius: 4px;
    font-size:13px
   }
`;

export default ViewZones